(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('passagesBranchTransaction', {
                parent: 'app',
                url: '/transaction/branchPassages',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/passagesTransaction.html',
                        controller: 'passengersTransactionsController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabPassagesTransaction('passagesBranchTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'branch';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('passagesUserTransaction', {
                parent: 'app',
                url: '/transaction/userPassages',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/passagesTransaction.html',
                        controller: 'passengersTransactionsController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabPassagesTransaction('passagesUserTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'user';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('passagesChannelTransaction', {
                parent: 'app',
                url: '/transaction/channelPassages',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/channelTransaction.html',
                        controller: 'passengersTransactionsController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabPassagesTransaction('passagesChannelTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'channel';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('cargoRegionTransaction', {
                parent: 'app',
                url: '/transaction/cargoRegion',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/cargoTransaction.html',
                        controller: 'cargoTransactionController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabCargoTransaction('cargoRegionTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'region';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('cargoBranchTransaction', {
                parent: 'app',
                url: '/transaction/cargoBranch',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/cargoTransaction.html',
                        controller: 'cargoTransactionController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabCargoTransaction('cargoBranchTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'branch';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('cargoUserTransaction', {
                parent: 'app',
                url: '/transaction/userCargo',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/cargoTransaction.html',
                        controller: 'cargoTransactionController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabCargoTransaction('cargoUserTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'user';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('luggageBranchTransaction', {
                parent: 'app',
                url: '/transaction/branchLuggage',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/luggageTransaction.html',
                        controller: 'luggageTransactionController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabLuggageTransaction('luggageBranchTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'branch';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('luggageUserTransaction', {
                parent: 'app',
                url: '/transaction/userLuggage',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/luggageTransaction.html',
                        controller: 'luggageTransactionController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabLuggageTransaction('luggageUserTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'user';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('forChargingGuidesPayable', {
                parent: 'app',
                url: '/transaction/forChargingGuidesPayable',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/forChargingGuidesPayable.html',
                        controller: 'forChargingGuidesPayableCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            cities: ['cityService', function(cityService){
                                return cityService.getCities()
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabCargoTransaction('forChargingGuidesPayable')
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('incomeRoute', {
                parent: 'app',
                url: '/transaction/incomeRoute',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/incomeRoute.html',
                        controller: 'incomeRouteCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            cities: ['cityService', function(cityService){
                                return cityService.getCities()
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabCargoTransaction('incomeRoute')
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('ssrBranchTransaction', {
                parent: 'app',
                url: '/transaction/branchSsr',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/ssrTransaction.html',
                        controller: 'ssrTransactionController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabSsrTransaction('ssrBranchTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'branch';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('ssrUserTransaction', {
                parent: 'app',
                url: '/transaction/userSsr',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/transactions/ssrTransaction.html',
                        controller: 'ssrTransactionController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['transactions']);
                            }],
                            currencies:['currencyService',function(currencyService){
                                return currencyService.getCurrencies();
                            }],
                            regions:['regionService',function(regionService){
                                return regionService.getRegions();
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabSsrTransaction('ssrUserTransaction')
                            }],
                            typeTransaction: [function () {
                                return 'user';
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            });
    }
})();
